<template>
  <div class="jm-button" :class="'button_'+status" @click="onClick">
    {{text}}
  </div>
</template>
<script>
export default {
  name: 'jm-button',
  props: {
    text: {
      type: String,
      default: 'button'
    },
    status: {
      type: String,
      default: 'normal'
    },
    click: {
      type: Function,
      default () {
      }
    },
    clickIn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  beforeMount () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    onClick () {
      const t = this
      if (t.clickIn) {
        t.$emit('click')
      }
    }
  }
}
</script>
<style scoped>
  .jm-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    user-select: none;
    -webkit-user-select: none;
  }
  .button_normal {
    background-color: #588AFF;
    font-size: calc(18 / 16 * 1rem);
    height: calc(45 / 16 * 1rem);
    color: #ffffff;
  }
  .mobile-phone .button_normal {
    font-size: calc(18 / 375 * 100vw);
    height: calc(43 / 375 * 100vw);
  }
  .button_normal:hover {
    background-color: #2A62E5;
  }
  .button_normal:active {
    background-color: #3D60B2;
  }
  .button_simple {
    font-size: 1rem;
    height: calc(38 / 16 * 1rem);
    border: 1px solid #588AFF;
    color: #588AFF;
  }
  .nav-bar .button_simple {
    border-radius: 8px;
  }
  .mobile-phone .button_simple {
    font-size: calc(18 / 375 * 100vw);
    height: calc(43 / 375 * 100vw);
  }
  .button_simple:hover {
    background-color: #EAF4FE;
  }
  .button_simple:active {
    border-color: #3D60B2;
    color: #3D60B2;
    background-color: #EAF4FE;
  }
  .button_little {
    font-size: 1rem;
    height: calc(28 / 16 * 1rem);
    border: 1px solid #cccccc;
    color: #666666;
  }
  .mobile-phone .button_little {
    font-size: calc(18 / 375 * 100vw);
    height: calc(43 / 375 * 100vw);
    background-color: #FFFFFF;
  }
  .button_little:hover {
    background-color: #f3f3f3;
  }
  .button_little:active {
    border-color: #666666;
    color: #333333;
    background-color: #f3f3f3;
  }
  .button_text {
    font-size: calc(18 / 16 * 1rem);
  }
  .button_text:hover {
    color: #588AFF;
  }
  .button_text:active {
    color: #3D60B2;
  }
  .button_text_simple {
    font-size: calc(16 / 16 * 1rem);
  }
  .button_text_simple:hover {
    color: #588AFF;
  }
  .button_text_simple:active {
    color: #3D60B2;
  }
  .button_text_little {
    font-size: calc(14 / 16 * 1rem);
  }
  .button_text_little:hover {
    color: #588AFF;
  }
  .button_text_little:active {
    color: #3D60B2;
  }
</style>
